
<div class="card">
  <h3 class="card-title mb-0">Setting List</h3>
  <Datatable [url]="url" [colDefs]="colDefs" [exportFilter]="false" (cellValueChanged)="onCellValueChanged($event)"></Datatable>
</div>
